package br.com.texeratx.boardgametimeapp.data.model.game

import kotlinx.serialization.Serializable

@Serializable
data class CreateGameRequest(
    val gameId: Long,
    val gameModeId: Long,
    val gameCategoryId: Long? = null,
    val spotifyUrl: String? = null,
    val manualUrl: String? = null,
    val status: Int = 1,
    val ownerIds: List<Long> = emptyList()
)
